import React from 'react';
import { Button } from 'grommet';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Loading } from 'components/Loading';
import { Text } from 'components/Wrapped';

const StyledButton = styled(Button)`
  ${(props) =>
    props.round === false &&
    css`
      border-radius: 100px;
    `};
  padding: 11px 12px;
`;

const WrappedButton = ({ children, color, primary, loading, size, ...rest }) => (
  <StyledButton
    label={
      !loading ? (
        <Text size={size} weight={500} style={{ lineHeight: '18px' }}>
          {children}
        </Text>
      ) : (
        <Loading color="var(--defaultTextColor)" size="25" type="Oval" />
      )
    }
    color={color}
    primary={primary ? primary : color === 'primary' && primary !== false ? true : false}
    {...rest}
  />
);

WrappedButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  primary: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.string,
  round: PropTypes.bool,
};

WrappedButton.defaultProps = {
  size: 'medium',
};

export default WrappedButton;
